import httpRequest from "@/utils/api";
import type {
  TutorLessonRefundRequest,
  TutorLessonRefundRequestListData,
  TutorLessonRefundRequestMarkRefundedPayload,
  TutorLessonRefundRequestRejectPayload,
  TutorLessonRefundRequestStatus,
} from "@/types/admin/tutorRefund";

enum API {
  refundRequests = "/admin/tutor/refund-requests",
  reject = "/admin/tutor/refund-requests/:requestId/reject",
  markRefunded = "/admin/tutor/refund-requests/:requestId/mark-refunded",
}

export const getAdminTutorRefundRequestsAPI = (params: {
  page: number;
  limit: number;
  status?: TutorLessonRefundRequestStatus | "";
  tenantId?: number | null;
}) => {
  const queryParams: {
    page: number;
    limit: number;
    status?: TutorLessonRefundRequestStatus;
    tenantId?: number;
  } = {
    page: params.page,
    limit: params.limit,
  };
  if (params.status) {
    queryParams.status = params.status;
  }
  if (params.tenantId) {
    queryParams.tenantId = params.tenantId;
  }
  return httpRequest.get<TutorLessonRefundRequestListData>({
    url: API.refundRequests,
    params: queryParams,
  });
};

export const rejectAdminTutorRefundRequestAPI = (
  requestId: number,
  payload: TutorLessonRefundRequestRejectPayload,
) => {
  return httpRequest.put<TutorLessonRefundRequest>({
    url: API.reject.replace(":requestId", requestId.toString()),
    data: payload,
  });
};

export const markAdminTutorRefundRequestRefundedAPI = (
  requestId: number,
  payload: TutorLessonRefundRequestMarkRefundedPayload,
) => {
  return httpRequest.put<TutorLessonRefundRequest>({
    url: API.markRefunded.replace(":requestId", requestId.toString()),
    data: payload,
  });
};
